<script>
    let { options, checkedValue, onSelectItem } = $props();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore element_invalid_self_closing_tag -->

{#each options as option}
    <div
        class="radiobutton {option.value === checkedValue ? '--selected' : ''}"
        onclick={() => onSelectItem(option.value)}
    >
        <i
            class="fal {option.value === checkedValue
                ? 'fa-check-circle'
                : 'fa-circle'}"
        />
        <span class="radiobutton__label">{option.text}</span>
    </div>
{/each}

<style lang="scss">
    @use "./styles/index.scss";
</style>
